const useHtmlContent = content => content?.replace(/\n/g, '<br>');

export default useHtmlContent;
